const navtabs = {
  state: () => ({
    isKeepAlive: false,
    refreshRouterName: "",
    navTabsList: [
      {
        label: '首页',
        path: '/distributor/index',
        name: 'd_index',
        isKeepAlive: true,
        lastTime: new Date().getTime(),
      },
      {
        label: '首页',
        path: '/supplier/index',
        name: 's_index',
        isKeepAlive: true,
        lastTime: new Date().getTime(),
      },
    ]
  }),
  mutations: {
    pushOrUpdateNavTabsList (state, obj) {     
      const existNavTab = state.navTabsList.find(item => item.path === obj.path)
      if (existNavTab) {
        existNavTab.lastTime = obj.lastTime
        existNavTab.query = obj.query
      } else {
        state.navTabsList.push(obj)
      }
    },
    setRefreshRouterName (state, name) {
      state.refreshRouterName = name
    },
    setIsKeepAlive (state, isKeep) {
      state.isKeepAlive = isKeep
    },
    deleteNavTabsList (state, item) {
      const index = state.navTabsList.findIndex(n => n.name === item.name);
      if (index > -1) {
        state.navTabsList.splice(index,1)
      }
    },
    closeAllNavTabsList (state) {
      state.navTabsList = [
        {
          label: '首页',
          path: '/distributor/index',
          name: 'd_index',
          lastTime: new Date().getTime(),
        },
        {
          label: '首页',
          path: '/supplier/index',
          name: 's_index',
          lastTime: new Date().getTime(),
        },
      ]
    }

  },
  actions: {
    setRefreshRouterName({commit}, name) {
      commit("setRefreshRouterName", name)
    },
    pushOrUpdateNavTabsList({commit}, obj) {
      commit("pushOrUpdateNavTabsList", obj)
    },
    setIsKeepAlive({commit}, isKeep) {
      commit("setIsKeepAlive", isKeep)
    },
    deleteNavTabsList({commit}, item) {
      commit("deleteNavTabsList", item)
    },
    closeAllNavTabsList({commit}) {
      commit("closeAllNavTabsList")
    },
    resetNavTabs({commit}) {
      commit("closeAllNavTabsList")
      commit("setRefreshRouterName", "")
      commit("setIsKeepAlive", false)
    }
  },
  getters: {
    refreshRouterName(state) {
      return state.refreshRouterName
    },
    navTabsList: (state) => (mode) => {
      return state.navTabsList.filter(item => {
        if (mode === 'distributor') {
          return item.name.split("_")[0] === 'd'
        } else if (mode === 'supplier') {
          return item.name.split("_")[0] === 's'
        } else {
          return false
        }
      })
    },
    isKeepAlive(state) {
      return state.isKeepAlive
    }
  }
}

export default navtabs
